import { API_BASE_URL } from '../../../../lib/api';

import { apiFetch } from '@/lib/apiFetch';
import { withTenant } from '../../../../lib/tenantHeaders';

const JSON_HEADERS = withTenant({ 'Content-Type': 'application/json' });

export const fetchCommodityTypes = async ({ limit = 10, offset = 1, query = {}, sort } = {}) => {
  const res = await apiFetch(`${API_BASE_URL}/commodity-types/filter`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify({ limit, offset, query, sort }),
  });
  return res.json();
};

export const createCommodityType = async (data) => {
  const res = await apiFetch(`${API_BASE_URL}/commodity-types`, {
    method: 'POST',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const updateCommodityType = async (id, data) => {
  const res = await apiFetch(`${API_BASE_URL}/commodity-types/${id}`, {
    method: 'PUT',
    headers: JSON_HEADERS,
    body: JSON.stringify(data),
  });
  return res.json();
};

export const deleteCommodityType = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/commodity-types/${id}`, {
    method: 'DELETE',
    headers: withTenant(),
  });
  return res.json();
};

export const toggleCommodityTypeStatus = async (id) => {
  const res = await apiFetch(`${API_BASE_URL}/commodity-types/${id}/toggle-status`, {
    method: 'POST',
    headers: JSON_HEADERS,
  });
  return res.json();
};

export const exportCommodityTypes = async ({ query = {}, sort } = {}) => {
  return fetchCommodityTypes({ limit: 10000, offset: 1, query, sort });
};
